// extracted by mini-css-extract-plugin
module.exports = {"section":"label-alumni-module--section--15EHX","header":"label-alumni-module--header--1gs7D","link":"label-alumni-module--link--19C1I"};